var CampaignActionCenter = require('./_campaignactioncenter')();
window.CampaignActionCenter = CampaignActionCenter;

CampaignActionCenter.init();